export function pdfOpen(pdf: string) {
  const pdfWindow = window.open("");
  if (pdfWindow)
    pdfWindow.document.write(
      `<iframe width='100%' height='100%' src='data:application/pdf;base64,${encodeURI(
        pdf
      )}'></iframe>`
    );
}
